import React, { useContext, useState } from 'react';
import Bear from './components/Bear';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { V3Context } from './V3Context';
import { navSections, pageTitle } from './navConfig';
import { IconMenu } from './icons';
import ErrorBoundary from './components/ErrorBoundary';

// The V3 layout, after ves-web's AppShell, Sidebar and Topbar: a side menu, a top bar and the page. Nothing of the current site's navbar is used.
export default function V3Shell() {
  const { user, signOut } = useContext(AuthContext);
  const { mode, toggleMode, lightEnabled } = useContext(V3Context);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const leave = () => {
    signOut();
    navigate('/v3/signin');
  };
  const name = (user && user.username) || '';
  const initials = name.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase() || '?';

  return (
    <div className="shell">
      <div className={`sidebar-backdrop${open ? ' show' : ''}`} onClick={() => setOpen(false)} role="presentation" />
      <aside className={`sidebar${open ? ' open' : ''}`} aria-label="Menu">
        <div className="brand">
          <div className="name" role="img" aria-label="CMA V3"><b>CMA</b><Bear name="gomi" size={34} className="brand-bear" /></div>
        </div>
        <nav className="nav" aria-label="Pages">
          {navSections.map((section) => (
            <div className="nav-section" key={section.label}>
              <div className="nav-label">{section.label}</div>
              {section.items.map((item) => (
                <NavLink key={item.path} to={item.path} onClick={() => setOpen(false)} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                  {item.bear ? <Bear name={item.bear} size={24} className="nav-bear" /> : <item.icon />}{item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-foot">
          <div className="who">
            <div className="avatar" aria-hidden="true">{initials}</div>
            <div style={{ color: 'var(--text)', fontWeight: 600 }}>{name}</div>
          </div>
          <a href="/home">Back to the current site</a>
        </div>
      </aside>
      <div className="main">
        <header className="topbar">
          <button type="button" className="menu-toggle" aria-label="Open the menu" onClick={() => setOpen((v) => !v)}><IconMenu /></button>
          <div className="breadcrumb"><b>{pageTitle(location.pathname)}</b></div>
          <div className="spacer" />
          {lightEnabled && (
            <button type="button" className="btn btn-ghost btn-sm" onClick={toggleMode} aria-label={mode === 'dark' ? 'Switch to the light theme' : 'Switch to the dark theme'}>
              {mode === 'dark' ? 'Light' : 'Dark'}
            </button>
          )}
          <button type="button" className="btn btn-ghost btn-sm" onClick={leave}>Sign out</button>
        </header>
        <main className="page">
          <ErrorBoundary key={location.pathname}><Outlet /></ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
